export default "__VITE_ASSET__CuFPBKO4__"